import React, { useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
// import { Link } from "react-router-dom";
import moment from "moment";
import { openCustomModal, closeCustomModal } from "views/lib/components/modals";
import { updateStatus } from "actions/chargers/station/actions";
import InfoPowerBank from "./info-power-bank";
import { ADMIN_ACTIONS } from "../../constants";

// Last users of each of the power banks at that station, along with dates
// Admin email
// Status: (possibility to change charging station status)

const Info = ({
                value,
                updateStatus,
                openCustomModal,
                closeCustomModal
              }) => {
  const [item, setItem] = useState(value);

  const handleStatusChange = (status) => {
    updateStatus(item.id, status);
    setItem(oldItem => ({
      ...oldItem,
      status,
    }));
  };

  const showPowerBankInfo = (pb) => {
    const modalObj = {
      id: "power-bank-last-history",
      modalSettings: {
        size: "sm",
        style: {
          width: 500
        }
      },
      header: "Power bank info",
      children: (
        <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
          <InfoPowerBank
            pb={pb}
          />
        </React.Suspense>
      ),
      handleClose: () => closeCustomModal(modalObj)
    };
    openCustomModal(modalObj);
  };

  return (
    <div className="card mb-0">
      <table className="table table-hover table-bordered table-striped table-align-middle table-sm mb-0">
        <tbody>
        <tr>
          <td>QR</td>
          <td>
            {item.qr}
          </td>
        </tr>
        <tr>
          <td>Owner’s</td>
          <td>
            {item.owners && Array.isArray(item.owners) ? item.owners.map(owner => `${owner.fullname}(${owner.percent})`)
              .join(", ") : ""}
          </td>
        </tr>
        <tr>
          <td>State</td>
          <td>
            {item.connected && item.connected.online ? "Online" : "Offline"}
          </td>
        </tr>
        <tr>
          <td>Status</td>
          <td>
            {item.status}
          </td>
        </tr>
        <tr>
          <td>Availability</td>
          <td>
            {item.powerBanksCount}/{item.slotsCount}
          </td>
        </tr>
        <tr>
          <td>Power bank ID's</td>
          <td>{Array.isArray(item.powerBanks) ? item.powerBanks.map(pb => (
            <div key={pb.id}>
              <button
                className="btn btn-link p-0"
                onClick={() => showPowerBankInfo(pb)}
              >
                {pb.id}
              </button>
            </div>
          )) : ""}</td>
        </tr>
        <tr>
          <td>Admin last action email</td>
          <td>{item.adminEmail}</td>
        </tr>
        <tr>
          <td>Admin last action date</td>
          <td>{item.adminActionDate
            ? moment(item.adminActionDate)
              .format("HH:mm YYYY-MM-DD")
            : "Not Set"}
          </td>
        </tr>

        <tr>
          <td>Status</td>
          <td>
            <select
              className="form-control form-control-sm"
              value={item.status}
              onChange={(ev) => {
                handleStatusChange(ev.target.value);
              }}
            >
              {Object.values(ADMIN_ACTIONS)
                .map(status => (
                  <option
                    value={status}
                    key={status}
                  >
                    {status}
                  </option>
                ))}
            </select>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  );
};

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  updateStatus: bindActionCreators(updateStatus, dispatch)
});

export default connect(null, mapStateToDispatch)(Info);



// WEBPACK FOOTER //
// ./src/views/pages/chargers/stations/single/info.js